"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Subject_1 = require("rxjs/Subject");
var logging_service_1 = require("./logging.service");
var log_event_model_1 = require("../models/log-event.model");
var uuid_1 = require("uuid");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var skill_service_1 = require("./skill.service");
var combineLatest_1 = require("rxjs/internal/observable/combineLatest");
var ChatContext = /** @class */ (function () {
    function ChatContext() {
    }
    return ChatContext;
}());
exports.ChatContext = ChatContext;
var NotificationService = /** @class */ (function () {
    function NotificationService(loggingService, skillService) {
        var _this = this;
        this.loggingService = loggingService;
        this.skillService = skillService;
        this.location$ = new Subject_1.Subject();
        this.chatState$ = new Subject_1.Subject();
        this.proactiveChatError$ = new Subject_1.Subject();
        window.addEventListener("message", function (ev) { return _this.receiveMessage(ev); });
        this.ready();
    }
    NotificationService.prototype.receiveMessage = function (event) {
        // TODO: Check the origin of event to prevent cross-site scripting attacks.
        console.log("Init: [ProactiveChat]: got a notification from " + JSON.stringify(event.origin) + " with event " + JSON.stringify(event.data));
        switch (event.data.message) {
            case 'uwfStartProactive':
                this.requestLocation();
                break;
            case 'uwfChatStateChanged':
                this.chatState$.next(event.data.isChatOpen);
                break;
            case 'uwfLocationChanged':
                var chatContext = {
                    sessionId: uuid_1.v4(),
                    location: event.data.location,
                    title: event.data.title,
                    chatRuleData: event.data.chatRuleData
                };
                this.location$.next(chatContext);
                break;
            case 'uwfProactiveError':
                this.proactiveChatError$.next(event.data.error);
                break;
            case 'uwfCreateProactiveChatLog':
                this.loggingService.logEvent(new log_event_model_1.LogEvent(event.data.eventCode, event.data.eventDescription));
                break;
            case 'uwfStartPeriodicSkillAvailabilityCheck':
                this.onStartSkillAvailabilityCheck(event.data);
                break;
            case 'uwfStopPeriodicSkillAvailabilityCheck':
                this.onStopSkillAvailabilityCheck();
                break;
            default:
                console.warn('[ProactiveChat] Unknown message received: ' + event.data.message);
        }
    };
    NotificationService.prototype.sendConditionFailEvent = function (error) {
        parent.postMessage({
            message: 'uwfProactiveConditionError',
            errorInfo: error
        }, '*');
    };
    NotificationService.prototype.sendApplicationStarted = function (sessionId) {
        parent.postMessage({
            message: 'uwfProactiveEngineLoaded',
            sessionId: sessionId
        }, '*');
    };
    NotificationService.prototype.requestLocation = function () {
        parent.postMessage('uwfGetLocation', '*');
    };
    NotificationService.prototype.ready = function () {
        parent.postMessage('uwfChatEngineReady', '*');
    };
    NotificationService.prototype.logWithTimestamp = function (tag, msg) {
        console.debug(tag + ': ' + msg + ' at ' + new Date().toLocaleTimeString());
    };
    NotificationService.prototype.onStartSkillAvailabilityCheck = function (options) {
        var _this = this;
        var skillAddressesFromPreChatForm = options.data.skillAddressesFromPreChatForm;
        var overriddenSkillAddresses = options.data.overriddenSkillAddresses;
        var isFormExternal = options.data.isFormExternal;
        var defaultSkillAddress$ = this.skillService.getDefaultSkillAddress().pipe(operators_1.catchError(function (err) {
            console.error('Failed to get default skill address');
            return rxjs_1.throwError(err);
        }), operators_1.tap(function () { return _this.logWithTimestamp('Init', 'Successfully fetched default skill address'); }));
        var skillAvailabilityCheckSeconds$ = this.skillService.getSkillAvailabilityCheckSeconds().pipe(operators_1.catchError(function (err) {
            console.error('Failed to get skill availability check seconds');
            return rxjs_1.throwError(err);
        }), operators_1.tap(function () { return _this.logWithTimestamp('Init', 'Successfully fetched skill availability check seconds'); }));
        combineLatest_1.combineLatest(defaultSkillAddress$, skillAvailabilityCheckSeconds$).subscribe({
            next: function (data) {
                var defaultSkillAddress = data[0], skillAvailabilityCheckSeconds = data[1];
                var skillAddresses;
                if (overriddenSkillAddresses) {
                    // Override skill addresses used for availability check
                    skillAddresses = overriddenSkillAddresses.split(',');
                }
                else if (overriddenSkillAddresses === '') {
                    // Skip availability check (with empty array)
                    skillAddresses = [];
                }
                else if (!isFormExternal) {
                    skillAddresses = skillAddressesFromPreChatForm.length ? skillAddressesFromPreChatForm : [defaultSkillAddress];
                }
                else { // Custom form is being used and there is no overriddenSkillAddresses defined
                    skillAddresses = [defaultSkillAddress];
                }
                _this.logWithTimestamp('Init', 'Check skill address for ' + JSON.stringify(skillAddresses));
                _this.checkSkillAvailability(skillAddresses);
                console.debug('Init: SkillAvailabilityCheckSeconds', skillAvailabilityCheckSeconds);
                if (skillAvailabilityCheckSeconds > 0) {
                    clearInterval(_this.skillAvailabilityCheckTimer);
                    _this.skillAvailabilityCheckTimer = setInterval(function () {
                        _this.checkSkillAvailability(skillAddresses);
                    }, skillAvailabilityCheckSeconds * 1000);
                }
            },
            error: function (err) {
                console.error(err);
            }
        });
    };
    NotificationService.prototype.onStopSkillAvailabilityCheck = function () {
        clearInterval(this.skillAvailabilityCheckTimer);
    };
    NotificationService.prototype.checkSkillAvailability = function (skillAddresses) {
        var _this = this;
        if (skillAddresses.length === 0) {
            this.skillService.makeSkillAvailable();
            return;
        }
        this.skillService.getSkillStatus(skillAddresses).subscribe({
            next: function (data) {
                var skillAvailabilityList = data;
                if (skillAvailabilityList.some(function (skillAvailability) { return skillAvailability.Status === 'open'; })) {
                    _this.skillService.makeSkillAvailable(); // Enable chat if any skills are open
                }
                else {
                    _this.skillService.hideChatButton();
                }
            }
        });
    };
    return NotificationService;
}());
exports.NotificationService = NotificationService;
